import { render, staticRenderFns } from "./SpecialCard.vue?vue&type=template&id=534668dc&scoped=true&"
import script from "./SpecialCard.vue?vue&type=script&lang=js&"
export * from "./SpecialCard.vue?vue&type=script&lang=js&"
import style0 from "./SpecialCard.vue?vue&type=style&index=0&id=534668dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534668dc",
  null
  
)

export default component.exports